import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import Success from "core/ReusableIcons/Success";
import { CustomBanner, MainText, SubText } from "./styles";

import colors from "core/colors";
import { PHOTO_DETAIL, ICON_DETAIL_PAGE } from "data/links";

const UnwrappedDownloadMessage = ({
    icon,
    photo,
    message = "Ready for download.",
    isPublicDomain = false,
    className
}) => {
    const contentType = photo ? "photo" : "icon";
    const subtext = `Great taste! Share this ${contentType}:`;
    const socialShareCreator = (photo || icon).creator.name;
    const socialShareLink = photo
        ? PHOTO_DETAIL.replace(":photoSlugWithId", photo.slugWithId)
        : ICON_DETAIL_PAGE.replace(":slugWithId", icon.slugWithId);

    return (
        <CustomBanner
            className={className}
            showSocialLinks
            socialShareType={contentType}
            socialShareCreator={socialShareCreator}
            socialShareLink={socialShareLink}
            accentColor={colors.alternative.lightMode.chartreuse}
            icon={isPublicDomain ? null : Success}
            iconTitle=""
        >
            <div>
                {isPublicDomain ? (
                    <MainText size={12}>
                        This public domain {contentType} is free to use.
                        <br />
                        Share this {contentType} with others:
                    </MainText>
                ) : (
                    <>
                        <MainText size={12} bold>
                            {message}
                        </MainText>
                        <SubText size={12}>{subtext}</SubText>
                    </>
                )}
            </div>
        </CustomBanner>
    );
};

UnwrappedDownloadMessage.propTypes = {
    photo: PropTypes.object,
    icon: PropTypes.object,
    message: PropTypes.string,
    isPublicDomain: PropTypes.bool,
    className: PropTypes.string
};

const DownloadMessage = styled(UnwrappedDownloadMessage)``;

export default DownloadMessage;
